import UserCollectionSearch from './UserCollectionSearch'
export default UserCollectionSearch
